import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { PureComponent, createRef } from 'react';
import { cx } from 'emotion';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import selectTable from 'react-table/lib/hoc/selectTable';
import TableHeader from './TableHeader';
import TablePagination from './TablePagination';
import TableSelect from './TableSelect';
import TableSpinner from './TableSpinner';
import TableNoData from './TableNoData';
var CheckboxReactTable = selectTable(ReactTable);
var defaultPageSizes = [10, 20, 50, 100];
var headerHeightAffectingProps = ['condensed', 'filterable'];

var Table =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Table, _PureComponent);

  function Table() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Table);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Table)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "tableRef", null);

    _defineProperty(_assertThisInitialized(_this), "containerRef", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      resolvedData: _this.props.data,
      // eslint-disable-line react/no-unused-state
      entireHeaderHeight: 0
    });

    _defineProperty(_assertThisInitialized(_this), "setMeasurements", function () {
      var _this$containerRef$cu = _this.containerRef.current.getElementsByClassName('ReactTable'),
          _this$containerRef$cu2 = _slicedToArray(_this$containerRef$cu, 1),
          rt = _this$containerRef$cu2[0];

      var headers = Array.from(rt.getElementsByClassName('rt-thead'));

      _this.setState({
        entireHeaderHeight: headers.reduce(function (agg, h) {
          return agg + h.offsetHeight;
        }, 0)
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getVisibleData", function () {
      if (!_this.tableRef) {
        return _this.props.data || [];
      }

      var resolvedState = _this.tableRef.getWrappedInstance().getResolvedState();

      var pageStart = resolvedState.page * resolvedState.pageSize;
      var pageEnd = (resolvedState.page + 1) * resolvedState.pageSize;
      return resolvedState.resolvedData.slice(pageStart, pageEnd);
    });

    _defineProperty(_assertThisInitialized(_this), "getPaginationProps", function () {
      var _this$props = _this.props,
          condensed = _this$props.condensed,
          perPageLabelText = _this$props.perPageLabelText,
          goToLabelText = _this$props.goToLabelText;
      return {
        condensed: condensed,
        perPageLabelText: perPageLabelText,
        goToLabelText: goToLabelText
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getTableRef", function (tableRef) {
      _this.tableRef = tableRef;
    });

    _defineProperty(_assertThisInitialized(_this), "getTheadThProps", function (state, row, column) {
      var sortable = [column.sortable, state.sortable, false].find(function (x) {
        return x != null;
      });
      var sorted = state.sorted.find(function (x) {
        return x.id === column.id;
      });
      return {
        sortable: sortable,
        sorted: sorted
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getSharedProps", function (_ref) {
      var loading = _ref.loading,
          condensed = _ref.condensed,
          filterable = _ref.filterable;
      return {
        loading: loading,
        entireHeaderHeight: _this.state.entireHeaderHeight,
        condensed: condensed,
        filterable: filterable
      };
    });

    return _this;
  }

  _createClass(Table, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setMeasurements();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (headerHeightAffectingProps.some(function (prop) {
        return _this2.props[prop] !== prevProps[prop];
      })) {
        this.setMeasurements();
      }
    } // get the height of the header to use as the offset to the LoadingComponent and NoDataComponent

  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          condensed = _this$props2.condensed,
          selectable = _this$props2.selectable;

      var props = _objectSpread({
        ref: this.getTableRef,
        className: cx(className, {
          'table-condensed': condensed
        }),
        // Callbacks for providing custom props to individual components
        getPaginationProps: this.getPaginationProps,
        getTheadThProps: this.getTheadThProps,
        getNoDataProps: this.getSharedProps,
        getLoadingProps: this.getSharedProps,
        ThComponent: TableHeader,
        // Defaults for pagination
        defaultPageSize: 10,
        pageSizeOptions: defaultPageSizes,
        LoadingComponent: TableSpinner,
        NoDataComponent: TableNoData,
        PaginationComponent: TablePagination,
        // Selection state and callbacks
        selectType: 'checkbox',
        selectWidth: 73,
        // Magic number that is 2 times left padding plus checkbox width.
        SelectAllInputComponent: TableSelect,
        SelectInputComponent: TableSelect,
        style: {
          position: 'relative'
        }
      }, this.props);

      return React.createElement("div", {
        ref: this.containerRef
      }, selectable ? React.createElement(CheckboxReactTable, props) : React.createElement(ReactTable, props));
    }
  }]);

  return Table;
}(PureComponent);

export { Table as default };
Table.propTypes = {
  className: PropTypes.string,
  condensed: PropTypes.bool,
  selectable: PropTypes.bool,
  data: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  keyField: PropTypes.any,
  // eslint-disable-line react/forbid-prop-types
  perPageLabelText: PropTypes.string,
  goToLabelText: PropTypes.string
};